<template>
  <FormKit
    type="select"
    label="Conference"
    v-model="modelValue"
    :options="conferencesOptions"
  />
</template>

<script lang="ts" setup>
import { useVModels } from '@vueuse/core';
import { useConferencesStore } from '~/stores/conferences.store';
const conferencesStore = useConferencesStore();
const { total, conferences } = storeToRefs(conferencesStore);
const { fetchConferences } = conferencesStore;
const props = defineProps<{
  modelValue: number | null;
}>();
const conferencesOptions = computed(() => {
  if (!conferences.value.length) return [];
  return [{ value: '', label: 'All' }].concat(
    conferences.value.map((c) => {
      return { value: c.id, label: c.abbreviation };
    })
  );
});
const emit = defineEmits(['update:modelValue']);
const { modelValue } = useVModels(props, emit);

onMounted(async () => {
  if (!total.value) {
    await fetchConferences();
  }
});
</script>
